export const strings = {
  title: 'Print Certificates',
  subtitle: "A programme's certificates, and who they were issued to",
  downloadCertificates: 'Download certificates',
  downloadList: 'Download user list',
  chooseProgram: 'Choose a programme to see who holds its certificates',
  empty: 'No matching certificates',
  actionFailed: 'The operation could not be completed',

  filter: {
    program: 'Programme',
    from: 'From',
    to: 'To',
  },

  columns: {
    username: 'Username',
    name: 'Name',
    email: 'Email',
    group: 'Department',
    issuedOn: 'Issued',
    expiresOn: 'Expires',
    daysLeft: 'Remaining',
  },
}
